import { Node_Type } from "./../../ricos-schema/legacy/wix/rich_content/v1/index.js";
import { TiptapContentResolver } from "./../../toolbars-v3/ContentResolver.js";
const isLinkInLinkPreview = TiptapContentResolver.create((content) => {
  if (Array.isArray(content)) {
    const node = content.find((node2) => {
      return node2.type.name === Node_Type.LINK_PREVIEW;
    });
    const url = node?.attrs?.link?.url;
    return typeof url === "string" && url !== "";
  }
  return false;
});
export {
  isLinkInLinkPreview
};
//# sourceMappingURL=is-link-in-link-preview.js.map
